const duplicateTranslationKey = (key: string): string => key;

export const translationStatistics_sv_part2 = {
  recentReports: "Senaste rapporter",
  reportJobsHelp:
    "Rapporter fortsätter i bakgrunden. Kom tillbaka hit för att ladda ned dem inom sju dagar.",
  reportQueued: "Rapporten är i kö. Du kan följa dess framsteg under Senaste rapporter.",
  reportJobsLoadError: "Kunde inte läsa in eller uppdatera rapporter. Försök igen.",
  reportRefusedScopeEmpty:
    "Den aktuella vyn har inga chatbotar att rapportera om. Välj chatbotar längst upp på sidan och försök igen.",
  reportRefusedAccessDenied:
    "Du har inte tillgång till alla valda chatbotar. Välj chatbotar du har tillgång till och försök igen.",
  reportRefusedQueueFull:
    "Det finns för många rapporter i kö just nu. Försök igen när en köad rapport har slutförts.",
  reportRefusedDateRange: "Den valda perioden är ogiltig. Kontrollera start- och slutdatum.",
  reportJob_queued: "I kö",
  reportJob_statistics: "Förbereder statistik",
  reportJob_analysis: "Analyserar konversationer",
  reportJob_rendering: "Genererar PDF",
  reportJob_uploading: "Sparar rapport",
  reportJob_delivery: "Skickar schemalagd rapport",
  reportJob_ready: "Klar att ladda ned",
  reportJob_failed: "Rapporten misslyckades",
  reportJob_cancelled: "Avbruten",
  reportJob_expired: "Utgången",
  reportJob_complete: "Klar",
  reportJobAnalysisInterrupted: "Analysen avbröts. Generera en ny rapport för att försöka igen.",
  reportJobTooLarge:
    "Den här rapporten är för stor att generera. Välj en kortare period eller färre chatbotar.",
  reportJobBusy:
    "Rapporttjänsten var upptagen och kunde inte slutföra rapporten. Kör den igen om några minuter.",
  reportJobTimeout:
    "Den här rapporten tog för lång tid att generera. Kör den igen eller välj en kortare period.",
  reportJobAccess: "Du har inte längre tillgång till alla chatbotar i den här rapporten.",
  reportJobDeliveryFailed: "Rapporten genererades, men dess e-post kunde inte skickas.",

  generateReport: "AI-rapport",
  generateReportTitle: "AI-statistikrapport",
  selectReportTimePeriod: "Välj tidsperiod för rapporten",
  selectReportEmne: "Välj ämne (valfritt)",
  allTopics: "Alla ämnen",
  cancel: "Avbryt",
  reportGeneratedSuccess: "Rapport genererad och nedladdad",
  reportGenerationError: "Fel vid generering av rapport",
  reportAiAnalysisFailed:
    "Rapporten genererades, men AI-insikterna kunde inte skapas. Försök igen senare.",
  includeTextAnalysis: "Inkludera textanalys (ordkorrelation)",
  includeGPTAnalysis: "Inkludera AI-analys och insikter",
  maxConversations: "Antal konversationer att analysera",
  loading: "Laddar...",
  companyInfo: "Företagsinformation",
  livechat: "Livechat",
  statistics: "Statistik",
  companyInfoPlaceholder: "Ange företagsinformation här...",
  startDate: "Startdatum",
  endDate: "Slutdatum",
  totalPurchases: "Totala köp",
  totalRevenue: "Total omsättning",
  averagePurchaseValue: "Genomsnittligt köpvärde",
  conversionRate: "Konverteringsgrad",
  storeTotalPurchases: "Butiksköp (alla)",
  storeTotalRevenue: "Butiksomsättning (alla)",
  storeAveragePurchaseValue: "Butikens genomsnittliga ordervärde (alla)",
  storeConversionRate: "Butikens konverteringsgrad (alla)",
  storeConversionRateVisitors: "Butikens konverteringsgrad (per daglig besökare)",
  returnRate: "Returfrekvens",
  returnValueRate: "Returnerad omsättning",
  returnUnitRate: "Returnerade varor",
  storeReturnRate: "Butikens returfrekvens (alla)",
  storeReturnValueRate: "Butikens returnerade omsättning (alla)",
  storeReturnUnitRate: "Butikens returnerade varor (alla)",
  returnCohortBasis: "Mogna beställningar",
  returnCurveTitle: "Returer per beställningsålder",
  returnCurveChatbotSeries: "Chatbot-konversationer",
  returnCurveStoreSeries: "Hela butiken",
  returnCurveFooter:
    "Siffror inom parentes är antalet mogna beställningar bakom varje punkt. Kunder som skriver till chatboten är inte ett slumpmässigt urval av kunder, så skillnaden mellan linjerna beskriver de två grupperna — den bevisar inte en effekt av chatboten.",
  trackingSince: "Spårning sedan",
  resolutionRate: "Lösningsfrekvens",
  handoverRequiredRate: "Kundservice krävs",
  fallbackRate: "Återfallsfrekvens",
  userRequestedCustomerServiceRate: "Användaren begärde kundservice",
  resolutionCategoryFilterApplied: "Visar konversationer med",
  ligegyldigRate: "Meningslös frekvens",

  exportConversations: "Exportera konversationer",
  exportConversationsTitle: "Exportera konversationer",
  exportCenterTitle: "Exportcenter",
  rawConversationsExport: "Rå konversationer",
  statisticsExport: "Statistik",
  exportFormat: "Format",
  runExport: "Kör export",
  includeChatbotId: "Inkludera chatbot-id",
  conversationDataMessageTypes: "Meddelandetyper för konversationsdata",
  statisticsMode: "Statistikläge",
  statisticsBreakdowns: "Uppdelningar",
  summaryFields: "Sammanfattningsfält",
  conversationDetails: "Konversationsdetaljer",
  exportTemplateName: "Mallnamn",
  saveTemplate: "Spara mall",
  loadTemplate: "Läs in mall",
  updateTemplate: "Uppdatera mall",
  templateSaved: "Mall sparad",
  templateUpdated: "Mall uppdaterad",
  templateDeleted: "Mall borttagen",
  templateName: "Mallnamn",
  templateNamePlaceholder: "Mallnamn",
  selectTemplate: "Välj mall",
  exportTemplates: "Exportmallar",
  savedTemplates: "Sparade mallar",
  saveAsTemplate: "Spara som mall",
  deleteTemplate: "Ta bort mall",
  confirmDeleteTemplate: "Ta bort den här mallen? Det går inte att ångra.",
  noTemplatesSaved: "Inga sparade mallar ännu",
  scheduleReport: "Schemalägg rapport",
  scheduleReports: "Schemalägg rapporter",
  recipientEmails: "Mottagaradresser",
  recipientEmailsHelp: "Separera flera e-postadresser med kommatecken",
  scheduleRecipients: "Mottagare",
  scheduleRecipientsPlaceholder: "email@exempel.se",
  scheduleFrequency: "Frekvens",
  daily: "Daglig",
  weekly: "Veckovis",
  monthly: "Månadsvis",
  weekday: "Veckodag",
  scheduleWeekdayMonday: "Måndag",
  scheduleWeekdayTuesday: "Tisdag",
  scheduleWeekdayWednesday: "Onsdag",
  scheduleWeekdayThursday: "Torsdag",
  scheduleWeekdayFriday: "Fredag",
  scheduleWeekdaySaturday: "Lördag",
  scheduleWeekdaySunday: "Söndag",
  dayOfMonth: "Dag i månaden",
  [duplicateTranslationKey("timeOfDay")]: "Tid på dygnet",
  scheduleTimeOfDay: "Tid på dygnet",
  scheduleCreated: "Rapportschema sparat",
  scheduleDeleted: "Rapportschema borttaget",
  deleteSchedule: "Ta bort schema",
  createSchedule: "Skapa schema",
  scheduleRequiresTemplate: "Spara eller läs in en mall innan du schemalägger.",
  saveTemplateBeforeScheduling: "Spara eller välj en mall innan du schemalägger",
  breakdownPerChatbot: "Uppdelning per chatbot",
  breakdownPerCategory: "Uppdelning per kategori",
  includeConversationDetails: "Inkludera konversationsdetaljer",
  includeUserMessages: "Inkludera användarmeddelanden",
  includeAiMessages: "Inkludera AI-meddelanden",
  includeSystemMessages: "Inkludera systemmeddelanden",
  includeMetricSummary: "Inkludera mätvärden",
  scheduleSectionTitle: "E-postschema",
  templatesSectionTitle: "Mallar",
  settingsUpdatedForNewOptions: "Mall uppdaterad med nya standardinställningar",
  exportTemplateCompatibilityNotice:
    "Mallen uppdaterades med nya standardalternativ. Granska den innan du exporterar.",
  selectExportTimePeriod: "Välj tidsperiod för exporten",
  exportCustomRangeRequired: "Välj både start- och slutdatum för en anpassad export.",
  exporting: "Exporterar...",
  exportToCsv: "Exportera till CSV",
  exportToXlsx: "Exportera till XLSX",
  exportSuccess: "Konversationer exporterade",
  exportError: "Det gick inte att exportera konversationer. Försök igen.",
  exportGeneratedSuccess: "Export genererad",
  exportTemplatesLoadError: "Det gick inte att läsa in exportmallar",
  exportFailed: "Export misslyckades",
  authTokenMissing: "Autentiseringstoken saknas",
  noConversationsFound: "Inga konversationer hittades för de valda kriterierna",
  splitByChatbotId: "Dela upp efter chatbot-ID",

  notifications: "Aviseringar",
  settingsButton: "Inställningar",
};
